import * as React from 'react';

export const UsersChecked = props => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1388 13.6914C17.8898 13.6914 17.6398 13.5984 17.4468 13.4134L15.9468 11.9754C15.5478 11.5934 15.5348 10.9604 15.9168 10.5614C16.2998 10.1624 16.9328 10.1494 17.3308 10.5314L18.1388 11.3064L20.5368 9.01038C20.9348 8.62938 21.5678 8.64038 21.9518 9.04138C22.3328 9.43938 22.3198 10.0724 21.9198 10.4544L18.8298 13.4134C18.6368 13.5984 18.3878 13.6914 18.1388 13.6914Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.78127 14.5156C4.80227 14.5156 2.57227 17.2696 2.57227 19.9996C2.57227 20.1986 2.65127 20.3896 2.79227 20.5306C2.93227 20.6706 3.12327 20.7496 3.32227 20.7496L16.2403 20.7316C16.6543 20.7306 16.9893 20.3946 16.9893 19.9816C16.9893 17.2606 14.7603 14.5156 9.78127 14.5156Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.78174 13.001C12.4697 13.001 14.6567 10.813 14.6567 8.125C14.6567 5.437 12.4697 3.25 9.78174 3.25C7.09374 3.25 4.90674 5.437 4.90674 8.125C4.90674 10.813 7.09374 13.001 9.78174 13.001Z"
      fill="#64748B"
    />
  </svg>
);
